<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="16" fill="#1EEAAD" />
    <path
      d="M8 16C8 16.6518 8.52837 17.1801 9.18014 17.1801H21.2417L17.9897 20.6132C17.5808 21.0449 17.5814 21.7212 17.9912 22.1521V22.1521C18.4304 22.614 19.1663 22.6157 19.6076 22.1558L24.8385 16.7054C25.2086 16.3198 25.21 15.7112 24.8417 15.3239L19.6362 9.84974C19.1967 9.38752 18.4597 9.38752 18.0202 9.84974V9.84974C17.6114 10.2796 17.6108 10.9543 18.0187 11.3849L21.2725 14.8199H9.18014C8.52836 14.8199 8 15.3482 8 16V16Z"
      fill="white" />
  </svg>
</template>
